import { render, staticRenderFns } from "./a-checkbox.vue?vue&type=template&id=51557f86&"
import script from "./a-checkbox.vue?vue&type=script&lang=js&"
export * from "./a-checkbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports